module.exports = __webpack_public_path__ + "static/portfolio-mas-11-aced7dd897ab16a101f3a2eb25fbfbe6.jpg";